var booking = (function () {
    let bookingData = {
        'expiresAt': '',
        'type': '',
        'area': {
            'id': '',
            'name': ''
        },
        'package': {
            'id': '',
            'group': '',
            'name': '',
            'price': '',
            'addons': []
        },
        'services': []
    };

    window.bookingData = bookingData;

    let summary_packages;
    let summary_services;
    let summary_area;
    let summary_package;
    let summary_addons;
    let summary_totals;
    let package_btn;
    let service_btn;
    let package_tab;
    let service_tab;

    let obj = {};

    function getSelectedPackageId() {
        return bookingData.package.id || document.querySelector('.tablinks_sub.active').getAttribute('data-id');
    }

    obj.init = function () {
        let area_selector = document.querySelector('#area_selector');
        if (area_selector) {
            area_selector.addEventListener('change', setArea);
        }

        summary_packages = document.getElementById('summary_packages');
        summary_services = document.getElementById('summary_services');
        summary_area = document.getElementById('summary_area');
        summary_package = document.getElementById('summary_package');
        summary_addons = document.getElementById('summary_addons');
        summary_totals = document.getElementById('summary_totals');
        package_btn = document.getElementById('package_btn');
        service_btn = document.getElementById('service_btn');
        package_tab = document.getElementById('package_tab');
        service_tab = document.getElementById('service_tab');

        loadData();
    };

    function saveData() {
        bookingData.expiresAt = new Date().getTime() + (60000 * 60);

        sessionStorage.setItem('bookingData', JSON.stringify(bookingData));

        displayStoredData();
    }

    function loadData() {
        if (sessionStorage.getItem('bookingData') == null) {
            return;
        }

        bookingData = JSON.parse(sessionStorage.getItem('bookingData'));

        let currentTime = new Date().getTime();
        if (currentTime > bookingData.expiresAt) {
            clearAll(true);
        } else {
            displayStoredData();
        }

        render();

        validateForm();
    }

    function calculatePackagePrice() {
        if (!bookingData.package.id || !bookingData.area.id) {
            return;
        }

        let packageDOMNode = document.querySelector(
            '.package-level-single[data-id="%d"][data-name="%s"]'
                .replace('%d', parseInt(bookingData.package.id))
                .replace('%s', bookingData.package.name)
        );

        bookingData.package.price = packageDOMNode.getAttribute('data-price-' + bookingData.area.id);
    }

    function setArea() {
        if (this.value === 'a0') {
            bookingData.type = '';
            bookingData.area.id = '';
            bookingData.area.name = '';
            summary_area.querySelectorAll('ul li span')[0].innerText = 'Ej valt';
        } else {
            if (bookingData.area.id.length > 0 && bookingData.area.id !== this.value && bookingData.package.id.length > 0) {
                var package_elem = document.querySelectorAll('[data-type=\'package\'][data-id=\'' + bookingData.package.id + '\'][data-name=\'' + bookingData.package.name + '\']');

                if (package_elem[0]) {
                    bookingData.package.price = package_elem[0].getAttribute('data-price-' + this.value);
                }
            }

            bookingData.type = 'package';
            bookingData.services = [];
            bookingData.area.id = this.value;
            bookingData.area.name = this.options[this.selectedIndex].text;
        }

        saveData();

        calculatePackagePrice();

        displayTotals();

        render();

        validateForm();
    }

    obj.addPackage = function (param) {
        var group_name = '';
        var input_included;
        var pkg = param.getAttribute('data-name');
        var package_id = param.getAttribute('data-id');
        var tablinks_sub = document.getElementsByClassName('tablinks_sub');
        var tabcontent_sub = document.getElementsByClassName('tabcontent_sub');

        for (let i = 0; i < tabcontent_sub.length; i++) {
            if (tabcontent_sub[i].style.display === 'block') {
                input_included = tabcontent_sub[i].querySelectorAll('[data-included=\'1\']');
            }
        }

        for (let i = 0; i < tablinks_sub.length; i++) {
            if (tablinks_sub[i].className.includes('active')) {
                group_name = tablinks_sub[i].innerText;
            }
        }

        if (bookingData.type === 'service') {
            bookingData.services = [];
        } else {
            if (bookingData.package.group !== group_name) {
                bookingData.package.addons = [];
            }
        }

        bookingData.type = 'package';
        bookingData.services = [];
        bookingData.package.group = group_name;
        bookingData.package.id = package_id;
        bookingData.package.name = pkg;

        saveData();

        calculatePackagePrice();

        if (input_included[0]) {
            input_included[0].checked = true;
            obj.addAddon(input_included[0]);
        } else {
            displayTotals();
        }

        render();

        validateForm();
    };

    obj.addAddon = function (param) {
        var addon_id = param.getAttribute('data-id');
        var addon_name = param.getAttribute('data-name');
        var addon_price = param.getAttribute('data-price');

        if (bookingData.type === 'service') {
            bookingData.services = [];
        }

        bookingData.type = 'package';

        if (bookingData.package.addons.find(s => s.id === addon_id)) {
            bookingData.package.addons = bookingData.package.addons.filter(s => s.id !== addon_id);
        } else {
            bookingData.package.addons.push({'id': addon_id, 'name': addon_name, 'price': addon_price});
        }

        saveData();

        clearSelectedServices();

        displayTotals();

        render();

        validateForm();
    };

    obj.addService = function (param) {
        var service_id = param.getAttribute('data-id');
        var service_name = param.getAttribute('data-name');
        var service_price = param.getAttribute('data-price');

        if (bookingData.type === 'package') {
            bookingData.area.id = '';
            bookingData.area.name = '';
            bookingData.package.id = '';
            bookingData.package.group = '';
            bookingData.package.name = '';
            bookingData.package.price = '';
            bookingData.package.addons = [];
        }

        bookingData.type = 'service';

        if (bookingData.services.find(s => s.id === service_id)) {
            bookingData.services = bookingData.services.filter(s => s.id !== service_id);
        } else {
            bookingData.services.push({'id': service_id, 'name': service_name, 'price': service_price});
        }

        saveData();

        displayTotals();

        render();

        validateForm();
    };

    function clear() {
        document.querySelector('#area_selector').value = 'a0';

        let levels = document.querySelectorAll('.package-level-single input');
        for (let i = 0; i < levels.length; i++) {
            levels[i].checked = false;
        }

        let addons = document.querySelectorAll('[data-type="addon"] input');
        for (let i = 0; i < addons.length; i++) {
            addons[i].checked = false;
        }

        let services = document.querySelectorAll('[data-type="service"] input');
        for (let i = 0; i < services.length; i++) {
            services[i].checked = false;
        }
    }

    function render() {
        clear();

        if (bookingData.area.id) {
            document.querySelector('#area_selector').value = bookingData.area.id;
            summary_area.querySelector('ul li span').innerText = bookingData.area.name;
        } else {
            summary_area.querySelector('ul li span').innerText = 'Ej valt';
        }

        if (bookingData.package.id) {
            let level = document.querySelector(
                '.package-level-single[data-id="%d"][data-name="%s"]'
                    .replace('%d', bookingData.package.id)
                    .replace('%s', bookingData.package.name)
            );

            level.querySelector('input[type="radio"]').checked = true;
            level.querySelector('span').textContent = bookingData.package.price
                ? formatPrice(bookingData.package.price)
                : '';

            summary_package.querySelector('ul li span').innerText = bookingData.package.group + ' - ' + bookingData.package.name;
        } else {
            summary_package.querySelector('ul li span').innerText = 'Ej valt';
        }

        if (bookingData.package.addons) {
            for (let i = 0, l = bookingData.package.addons.length, addon; i < l; ++i) {
                addon = bookingData.package.addons[i];

                document.querySelector(
                    '#item-%package [data-type="addon"][data-id="%d"] input'
                        .replace('%package', getSelectedPackageId())
                        .replace('%d', addon.id)
                ).checked = true;
            }
        }

        let addons_text = '';
        if (bookingData.package.addons.length > 0) {
            bookingData.package.addons.forEach(function (data, index) {
                addons_text += '<span>' + data.name + '</span>';
            });

            addons_text = addons_text.slice(0, -2);

        } else {
            addons_text = 'Ej valt';
        }

        summary_addons.querySelectorAll('ul li span')[0].innerHTML = addons_text;

        if (bookingData.services) {
            for (let i = 0, l = bookingData.services.length, service; i < l; ++i) {
                service = bookingData.services[i];

                document.querySelector('[data-type="service"][data-id="%d"] input'.replace('%d', service.id)).checked = true;
            }
        }

        summary_services.innerHTML = '';
        if (bookingData.services.length > 0) {
            bookingData.services.forEach(function (data, index) {
                var li = document.createElement('li');

                li.innerHTML = '<p>' + data.name + '</p><span>' + formatPrice(data.price) + '</span>';
                summary_services.appendChild(li);
            });
        } else {
            summary_services.innerHTML = 'Ej valt';
        }
    }

    function formatPrice(price) {
        return Number(price).toLocaleString('sv-Se', {
            currency: 'SEK',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    function displayStoredData() {
        var contact_form = document.querySelector('div.contact-form.box p strong');

        if (bookingData.type === 'package') {
            package_btn.className = 'tablinks active';
            service_btn.className = 'tablinks phone';

            package_tab.style.display = 'block';
            package_tab.className += ' active';

            service_tab.className.replace(' active', '');
            service_tab.style.display = 'none';

            contact_form.innerHTML = contact_form.innerHTML.replace('2.', '3.');

            document.querySelectorAll('#summary_packages')[0].removeAttribute('style');
            document.querySelectorAll('#summary_services')[0].style.display = 'none';

            if (bookingData.package.id.length > 0) {
                tabcontentSub = document.getElementsByClassName('tabcontent_sub');
                for (i = 0; i < tabcontentSub.length; i++) {
                    tabcontentSub[i].style.display = 'none';
                }

                tablinksSub = document.getElementsByClassName('tablinks_sub');
                for (i = 0; i < tablinksSub.length; i++) {
                    if (bookingData.package.id === tablinksSub[i].getAttribute('data-id')) {
                        document.getElementById('item-' + bookingData.package.id).style.display = 'block';
                        if (!tablinksSub[i].className.includes('active')) {
                            tablinksSub[i].className += ' active';
                        }
                    } else {
                        tablinksSub[i].className = tablinksSub[i].className.replace(' active', '');
                    }
                }
            }

            if (bookingData.area.id) {
                var area_selector = document.querySelector('#area_selector');
                area_selector.value = bookingData.area.id;
                summary_area.querySelectorAll('ul li span')[0].innerText = area_selector.options[area_selector.selectedIndex].text;
            }

            if (bookingData.package.id) {
                let selector = '.package-level-single[data-id="%d"][data-name="%s"] input[name="level"]'
                    .replace('%d', bookingData.package.id)
                    .replace('%s', bookingData.package.name);
                document.querySelector(selector).checked = true;
                summary_package.querySelectorAll('ul li span')[0].innerText = bookingData.package.group + ' - ' + bookingData.package.name;
            }

            if (bookingData.package.addons.length > 0) {
                var addons_text = '';

                if (bookingData.package.addons.length > 0) {
                    bookingData.package.addons.forEach(function (data, index) {
                        addons_text += '<span>' + data.name + '</span>';
                    });
                    addons_text = addons_text.slice(0, -2);
                } else {
                    addons_text = 'Ej valt';
                }

                summary_addons.querySelectorAll('ul li span')[0].innerHTML = addons_text;

                //Find all selected addons and set them to checked
                var addons_elems = document.querySelectorAll('[data-type=\'addon\']');
                bookingData.package.addons.forEach(function (data, index) {
                    for (var i = 0; i < addons_elems.length; i++) {
                        var this_id = addons_elems[i].getAttribute('data-id');
                        if (this_id === data.id) {
                            addons_elems[i].checked = true;
                        }
                    }
                });

                clearSelectedServices();
            }

            displayPackagePrices();

        } else if (bookingData.type === 'service') {
            package_btn.className = 'tablinks';
            service_btn.className = 'tablinks phone active';

            package_tab.className.replace(' active', '');
            package_tab.style.display = 'none';

            service_tab.style.display = 'block';
            service_tab.className += ' active';

            contact_form.innerHTML = contact_form.innerHTML.replace('4.', '2.');
            document.querySelectorAll('#summary_services')[0].removeAttribute('style');
            document.querySelectorAll('#summary_packages')[0].style.display = 'none';

            if (bookingData.services.length > 0) {
                summary_services.innerHTML = '';
                var services_elems = document.querySelectorAll('[data-type=\'service\']');

                bookingData.services.forEach(function (data, index) {
                    for (var i = 0; i < services_elems.length; i++) {
                        var this_id = services_elems[i].getAttribute('data-id');
                        if (this_id === data.id) {
                            services_elems[i].checked = true;
                        }
                    }

                    var li = document.createElement('li');
                    var addon_price = Number(data.price).toLocaleString('sv-Se', {
                        currency: 'SEK',
                        style: 'currency',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    });
                    li.innerHTML = '<p>' + data.name + '</p><span>' + addon_price + '</span>';
                    summary_services.appendChild(li);
                });

                clearSelectedPackage();
                clearSelectedAddons();
            }
        }

        displayTotals();
    }

    function displayTotals() {
        let total_sum = 0;
        if (bookingData.package.price) {
            if (isNumeric(bookingData.package.price)) {
                total_sum = Number(bookingData.package.price);
            }
        }

        if (bookingData.package.addons.length > 0) {
            bookingData.package.addons.forEach(function (data, index) {
                if (isNumeric(data.price)) {
                    total_sum += Number(data.price);
                }
            });
        }

        if (bookingData.services.length > 0) {
            bookingData.services.forEach(function (data, index) {
                if (isNumeric(data.price)) {
                    total_sum += Number(data.price);
                }
            });
        }

        if (bookingData.package.price === 'Offert') {
            total_sum = 'Offert';
        } else {
            total_sum = Number(total_sum).toLocaleString('sv-Se', {
                currency: 'SEK',
                style: 'currency',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        }

        summary_totals.querySelectorAll('span')[0].innerText = total_sum;
    }

    function displayPackagePrices() {
        var priceElems = document.querySelectorAll('.package-level-single-right span');
        var radios = document.getElementsByClassName('package-level-single');

        for (var i = 0; i < priceElems.length; i++) {
            if (radios[i]) {
                var price = radios[i].getAttribute('data-price-' + bookingData.area.id);
                if (price) {
                    if (!isNaN(price)) {
                        price = formatPrice(price);
                    }

                    priceElems[i].innerHTML = price;
                } else {
                    priceElems[i].innerHTML = '';
                }
            }
        }
    }

    // Validate bookingData and enable form if all is ok
    function validateForm() {
        var isValid = false;
        let form_package = document.querySelector('#input_4_13');
        let form_addons = document.querySelector('#input_4_14');
        let form_services = document.querySelector('#input_4_15');
        let contact_form_box = document.querySelector('div.contact-form.box');

        if (bookingData !== null) {
            if (bookingData.type === 'package') {
                if (bookingData.package.name.length > 0 && bookingData.area.id.length > 0) {
                    form_package.value = bookingData.package.group + ' - ' + bookingData.package.name + ' ' + formatPrice(bookingData.package.price);

                    if (bookingData.package.addons.length > 0) {
                        var addons_packages = '';
                        bookingData.package.addons.forEach(function (data, index) {
                            addons_packages += data.name + ' ' + formatPrice(data.price) + ', ';
                        });

                        form_addons.value = addons_packages;
                    }

                    isValid = true;
                }
            } else if (bookingData.type === 'service') {
                if (bookingData.services.length > 0) {
                    var addons_services = '';
                    bookingData.services.forEach(function (data, index) {
                        addons_services += data.name + ' ' + formatPrice(data.price) + ', ';
                    });

                    form_services.value = addons_services;
                    isValid = true;
                }
            }
        }

        if (isValid === true) {
            contact_form_box.className = 'contact-form box';
        } else {
            contact_form_box.className = 'contact-form box inactive';
        }
    }

    // Clear all services
    function clearSelectedServices() {
        var tmp_services_elems = document.querySelectorAll('[data-type=\'service\']');
        for (var i = 0; i < tmp_services_elems.length; i++) {
            tmp_services_elems[i].checked = false;
        }
    }

    // Clear all packages
    function clearSelectedPackage() {
        var radios = document.getElementsByName('level');
        for (var i = 0; i < radios.length; i++) {
            radios[i].checked = false;
        }
    }

    // Clear all addons
    function clearSelectedAddons() {
        var tmp_addons_elems = document.querySelectorAll('[data-type=\'addon\']');
        for (var i = 0; i < tmp_addons_elems.length; i++) {
            tmp_addons_elems[i].checked = false;
        }
    }

    // Clear all data
    function clearAll(area) {
        sessionStorage.clear();

        bookingData = {
            expiresAt: '',
            type: '',
            area: {
                id: '',
                name: ''
            },
            'package': {
                id: '',
                group: '',
                name: '',
                price: '',
                addons: []
            },
            services: []
        };

        if (area === true) {
            document.querySelector('#area_selector').selectedIndex = 0;
        }
    }

    function isNumeric(value) {
        return /^-?\d+$/.test(value);
    }

    obj.openBookingTab = function (evt, tabType) {
        // Declare all variables
        var i, tabcontent, tablinks;
        var contact_form = document.querySelector('div.contact-form.box p strong');

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName('tabcontent');
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = 'none';
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName('tablinks');
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(' active', '');
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(tabType + '_tab').style.display = 'block';
        evt.currentTarget.className += ' active';

        if (tabType === 'service') {
            contact_form.innerHTML = contact_form.innerHTML.replace('4.', '2.');
        } else {
            contact_form.innerHTML = contact_form.innerHTML.replace('2.', '4.');
        }
    };

    obj.openSubTab = function (evt, packageSubName) {
        // Declare all variables
        var i, tabcontentSub, tablinksSub;

        // Get all elements with class="tabcontent_sub" and hide them
        tabcontentSub = document.getElementsByClassName('tabcontent_sub');
        for (i = 0; i < tabcontentSub.length; i++) {
            tabcontentSub[i].style.display = 'none';
        }

        // Get all elements with class="tablinks_sub" and remove the class "active"
        tablinksSub = document.getElementsByClassName('tablinks_sub');
        for (i = 0; i < tablinksSub.length; i++) {
            tablinksSub[i].className = tablinksSub[i].className.replace(' active', '');
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(packageSubName).style.display = 'block';
        evt.currentTarget.className += ' active';
    };

    obj.clearAll = function () {
        clearAll(true);
    };

    return obj;
})();

var bookingLight = (function () {
    var bookingData = {
        'expiresAt': '',
        'type': '',
        'area': {
            'id': '',
            'name': ''
        },
        'package': {
            'id': '',
            'group': '',
            'name': '',
            'price': '',
            'addons': []
        },
        'services': []
    };

    let obj = {};

    obj.init = function () {
        var area_selector = document.querySelector('#area_selector');
        if (area_selector) {
            area_selector.addEventListener('change', setArea);
        }
    };

    function saveData() {
        bookingData.expiresAt = new Date().getTime() + (60000 * 60);

        sessionStorage.setItem('bookingData', JSON.stringify(bookingData));
    }

    function setArea() {
        if (this.value === 'a0') {
            bookingData.type = '';
            bookingData.area.id = '';
            bookingData.area.name = '';
        } else {
            bookingData.type = 'package';
            bookingData.services = [];
            bookingData.area.id = this.value;
            bookingData.area.name = this.options[this.selectedIndex].text;
        }

        saveData();
        displayPackagePrices();
    }

    function displayPackagePrices() {
        let packages = document.querySelectorAll('.sub-package');

        for (let i = 0, l = packages.length, pkg; i < l; i++) {
            pkg = packages[i];
            let price_holder = pkg.querySelector('.price_holder');
            var price_from = price_holder.getAttribute('data-from-price');
            var price = bookingData.area.id !== ''
                ? pkg.getAttribute('data-price-' + bookingData.area.id)
                : price_from;
            var span = price_holder.getElementsByTagName('span')[0];
            if (bookingData.area.id === 'a0') {
                price = price_from;
            }

            if (!isNaN(price)) {
                price = Number(price).toLocaleString('sv-Se', {
                    currency: 'SEK',
                    style: 'currency',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
            }

            if (bookingData.area.id === '') {
                span.innerHTML = 'Fr&aring;n ' + price + ' kr';
            } else {
                span.innerHTML = price;
            }
        }
    }

    obj.addPackage = function (param) {
        var tablinks = document.getElementsByClassName('tablinks');
        var group_name = '';
        var pkg = param.getAttribute('data-name');
        var package_id = param.getAttribute('data-id');
        var price = param.getAttribute('data-price-' + bookingData.area.id);

        for (let i = 0; i < tablinks.length; i++) {
            if (tablinks[i].className.includes('active')) {
                group_name = tablinks[i].innerText;
            }
        }

        if (group_name.length === 0) {
            group_name = param.getAttribute('data-group-name');
        }

        if (bookingData.type.length === 0) {
            bookingData.type = 'package';
        }

        bookingData.package.group = group_name;
        if (package_id.length > 0) {
            bookingData.package.id = package_id;
            bookingData.package.name = pkg;
            bookingData.package.price = price;
        }

        saveData();

        window.location.href = '/boka-husbesiktning';
    };

    return obj;
})();
